import React, { useEffect, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import ModelPageBanner from "../components/ModelPageBanner";
import "./VardaanMs.css";

// Product images
import product1 from "../assets/products/pside-1.png";
import product2 from "../assets/products/ev-white-ss.png";
import product3 from "../assets/products/ev-blue-ss.png";
import product4 from "../assets/products/pside-4.png";
import product5 from "../assets/products/pside-5.png";
import evimg2 from "../assets/products/ev-white-ss.png"

// Specs component
import ProductPageSpec from "../components/ProductPageSpec";

const VardaanSS = () => {
  const productImages = [product1, product2, product3, product4, product5];

  const intervalRef = useRef(null);
  const indexRef = useRef(0); // internal index, no state needed

  // Auto rotate
  useEffect(() => {
    intervalRef.current = setInterval(() => {
      indexRef.current = (indexRef.current + 1) % productImages.length;
    }, 2000);

    return () => clearInterval(intervalRef.current);
  }, [productImages.length]);

  // Scroll to change image
  useEffect(() => {
    const handleScroll = () => {
      indexRef.current = (indexRef.current + 1) % productImages.length;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [productImages.length]);

  return (
    <div className="product1-page">
      {/* Section 1 */}
      <section>
        <ModelPageBanner />
      </section>

      {/* Section 2 */}
      <section className="product1-section2">
        <Container>

          {/* Row 1 */}
          <Row className="align-items-center mb-5 justify-content-between">
            <Col md={5}>
              <div className="product1-img-wrapper">
                <img src={product1} alt="Product" className="product1-img" />
              </div>
            </Col>
            <Col md={6}>
              <div className="product1-spec-table">
                <h4>Vardaan SS 1250W DLX</h4>
                <table>
                  <tbody>
                    <tr><td>Power</td><td>1250W</td></tr>
                    <tr><td>Battery</td><td>Eastman Lead Acid</td></tr>
                    <tr><td>Battery warranty</td><td >15 Months</td></tr>
                    <tr><td>Battery Quantity</td><td className="highlight">4 (Four Nos)</td></tr>
                    <tr><td>Battery Capacity</td><td className="highlight">135/140AH, 48V</td></tr>
                  </tbody>
                </table>
              </div>
            </Col>
          </Row>

    {/* Row 2 */}
    <Row className="align-items-center mb-5 justify-content-between flex-row-reverse">
      <Col md={5}>
        <div className="product1-img-wrapper">
          <img src={product2} alt="Product" className="product1-img" />
        </div>
      </Col>
      <Col md={6}>
        <div className="product1-spec-table">
          <h4>Vardaan SS 1250W DLX</h4>
          <table>
            <tbody>
              <tr><td>Power</td><td>1250W</td></tr>
              <tr><td>Battery</td><td>Eastman Lead Acid</td></tr>
              <tr><td>Battery warranty</td><td >15 Months</td></tr>
              <tr><td>Battery Quantity</td><td className="highlight">5 (Five Nos)</td></tr>
              <tr><td>Battery Capacity</td><td className="highlight">135/140AH, 60V</td></tr>
            </tbody>
          </table>
        </div>
      </Col>
    </Row>

    {/* Row 3 */}
    <Row className="align-items-center mb-5 justify-content-between">
      <Col md={5}>
        <div className="product1-img-wrapper">
          <img src={product3} alt="Product" className="product1-img" />
        </div>
      </Col>
      <Col md={6}>
        <div className="product1-spec-table">
          <h4>Vardaan SS 1250W DLX</h4>
          <table>
            <tbody>
              <tr><td>Power</td><td >1250W</td></tr>
              <tr><td>Battery</td><td className="highlight">Eastman Lithium</td></tr>
              <tr><td>Battery warranty</td><td className="highlight">36 Months</td></tr>
              <tr><td>Battery Quantity</td><td className="highlight">1 (One Nos)</td></tr>
              <tr><td>Battery Capacity</td><td className="highlight">105 AH, 48V</td></tr>
            </tbody>
          </table>
        </div>
      </Col>
    </Row>

    {/* Row 4 */}
    {/* <Row className="align-items-center mb-5 justify-content-between flex-row-reverse">
      <Col md={5}>
        <div className="product1-img-wrapper">
          <img src={product4} alt="Product" className="product1-img" />
        </div>
      </Col>
      <Col md={6}>
        <div className="product1-spec-table">
          <h4>Vardaan SS 1200W </h4>
          <table>
            <tbody>
              <tr><td>Power</td><td>1200W</td></tr>
              <tr><td>Battery</td><td>Eastman</td></tr>
              <tr><td>Battery warranty</td><td>15 Months</td></tr>
              <tr><td>Battery Count</td><td className="highlight">5 (Five)</td></tr>
              <tr><td>AH</td><td>135/140AH</td></tr>
            </tbody>
          </table>
        </div>
      </Col>
    </Row> */}

    {/* Row 5 */}
    {/* <Row className="align-items-center mb-5 justify-content-between">
      <Col md={5}>
        <div className="product1-img-wrapper">
          <img src={product5} alt="Product" className="product1-img" />
        </div>
      </Col>
      <Col md={6}>
        <div className="product1-spec-table">
          <h4>Vardaan SS 1000W </h4>
          <table>
            <tbody>
              <tr><td>Power</td><td>1200W</td></tr>
              <tr><td>Battery</td><td>Eastman</td></tr>
              <tr><td>Battery warranty</td><td className="highlight">36 Months</td></tr>
              <tr><td>Battery Count</td><td className="highlight">1 (One)</td></tr>
              <tr><td>AH</td><td className="highlight">1000AH</td></tr>
            </tbody>
          </table>
        </div>
      </Col>
    </Row> */}
  </Container>
</section>


      {/* Specs Component */}
 <ProductPageSpec image={evimg2} />
    </div>
  );
};

export default VardaanSS;
